const Footer = () => {
    return(
        <div id="author-info">
            <p>
                Challenge by <a href="https://www.freecodecamp.org/" target="_blank" rel='noreferrer'>freeCodeCamp</a> and coded by <a href="https://barbaraaliverti.github.io/" target="_blank" rel='noreferrer'>Bárbara Aliverti</a>
                
            </p>
        </div>
    )
}

export default Footer;